export const ACCEPT_FRIEND_REQUEST = 'api/ACCEPT_FRIEND_REQUEST';
export const ADD_FRIEND_TO_GROUP = 'api/ADD_FRIEND_TO_GROUP';
export const CHALLENGE = 'api/CHALLENGE';
export const CHALLENGE_ENTRIES = 'api/CHALLENGE_ENTRIES';
export const CHALLENGE_HISTORY = 'api/CHALLENGE_HISTORY';
export const CLAIM_CREDIT = 'api/CLAIM_CREDIT';
export const CLEAR_FAVORITES = 'api/CLEAR_FAVORITES';
export const COMPATIBLE_CHALLENGES = 'api/COMPATIBLE_CHALLENGES';
export const COMPETITIONS_LIST = 'api/COMPETITIONS_LIST';
export const COMPLETED_CHALLENGES = 'api/COMPLETED_CHALLENGES';
export const CONTACT = 'api/CONTACT';
export const COUNTRIES = 'api/COUNTRIES';
export const CREATE_CHALLENGE = 'api/CREATE_CHALLENGE';
export const CREATE_FRIEND_REQUEST = 'api/CREATE_FRIEND_REQUEST';
export const CREATE_GROUP = 'api/CREATE_GROUP';
export const DELETE_CHALLENGES = 'api/DELETE_CHALLENGES';
export const DELETE_LINEUPS = 'api/DELETE_LINEUPS';
export const DELETE_GROUP = 'api/DELETE_GROUP';
export const DELETE_PAYMENT_METHOD = 'api/DELETE_PAYMENT_METHOD';
export const DEPOSIT = 'api/DEPOSIT';
export const RAZORPAY_DEPOSIT = 'api/RAZORPAY_DEPOSIT';
export const FACEBOOK_SIGN_IN = 'api/FACEBOOK_SIGN_IN';
export const FANTASY_INSIDER_LOAD_PROJECTIONS = 'api/FANTASY_INSIDER_LOAD_PROJECTIONS';
export const FANTASY_INSIDER_SAVE_PROJECTION = 'api/FANTASY_INSIDER_SAVE_PROJECTION';
export const FAQS = 'api/FAQS';
export const FORM_FIELDS = 'api/FORM_FIELDS';
export const USER_PLAYUP_CAMPAIGN_STATUS = 'api/USER_PLAYUP_CAMPAIGN_STATUS';
export const USER_CREATE_PLAYUP_ACCOUNT = 'api/USER_CREATE_PLAYUP_ACCOUNT';
export const FRIEND_REQUESTS = 'api/FRIEND_REQUESTS';
export const FRIENDS = 'api/FRIENDS';
export const GAMES = 'api/GAMES';
export const GIFTSTORE_PRODUCTS = 'api/GIFTSTORE_PRODUCTS';
export const GIFTSTORE_PURCHASES = 'api/GIFTSTORE_PURCHASES';
export const GIFTSTORE_REDEEM = 'api/GIFTSTORE_REDEEM';
export const GROUP = 'api/group';
export const GROUPS = 'api/GROUPS';
export const H2H_CHALLENGE = 'api/H2H_CHALLENGE';
export const HALL_OF_FAME = 'api/HALL_OF_FAME';
export const INVITE_OTHERS = 'api/INVITE_OTHERS';
export const JACKPOT_SLOTS = 'api/JACKPOT_SLOTS';
export const JACKPOT_SLOTS_GET_WINNERS = 'api/JACKPOT_SLOTS_GET_WINNERS';
export const LIMITS = 'api/LIMITS';
export const LIVE_CHALLENGES = 'api/LIVE_CHALLENGES';
export const MY_COMPLETED_CHALLENGES = 'api/MY_COMPLETED_CHALLENGES';
export const MY_LINEUP = 'api/MY_LINEUP';
export const MY_LINEUPS = 'api/MY_LINEUPS';
export const MY_LINEUP_CHALLENGES = 'api/MY_LINEUP_CHALLENGES';
export const MY_LIVE_CHALLENGES = 'api/MY_LIVE_CHALLENGES';
export const MY_SLATE_LINEUPS = 'api/MY_SLATE_LINEUPS';
export const MY_UPCOMING_CHALLENGES = 'api/MY_UPCOMING_CHALLENGES';
export const UPDATE_MY_LINEUP = 'api/UPDATE_MY_LINEUP';
export const NOTIFICATIONS = 'api/NOTIFICATIONS';
export const ONESPORT_PLAYER_COMPETITION = 'api/ONESPORT_PLAYER_COMPETITION';
export const ONESPORT_PLAYER_GAME = 'api/ONESPORT_PLAYER_GAME';
export const OPPONENT_ENTRY = 'api/OPPONENT_ENTRY';
export const PASSWORD_RESET = 'api/PASSWORD_RESET';
export const PLAYER_SWAP_MINE = 'api/PLAYER_SWAP_MINE';
export const PLAYER_SWAP_SELECT_SLATE = 'api/PLAYER_SWAP_SELECT_SLATE';
export const PLAYER_SWAP_SLATES = 'api/PLAYER_SWAP_SLATES';
export const PLAYER_SWAP_OTHER = 'api/PLAYER_SWAP_OTHER';
export const PLAYER_SWAP_SUBMISSION = 'api/PLAYER_SWAP_SUBMISSION';
export const PRIZES = 'api/PRIZES';
export const PXC_SIGN_IN = 'api/PXC_SIGN_IN';
export const RAPIDFIRE_LIVE = 'api/RAPIDFIRE_LIVE';
export const RAPIDFIRE_UPCOMING = 'api/RAPIDFIRE_UPCOMING';
export const REMOVE_FRIEND = 'api/REMOVE_FRIEND';
export const REMOVE_FRIEND_FROM_GROUP = 'api/REMOVE_FRIEND_FROM_GROUP';
export const REMOVE_FRIEND_REQUEST = 'api/REMOVE_FRIEND_REQUEST';
export const REQUEST_EMAIL_VERIFICATION = 'api/REQUEST_EMAIL_VERIFICATION';
export const REQUEST_PHONE_VERIFICATION = 'api/REQUEST_PHONE_VERIFICATION';
export const RULES = 'api/RULES';
export const SEARCH_USER = 'api/SEARCH_USER';
export const SELF_EXCLUDE = 'api/SELF_EXCLUDE';
export const SETTINGS_BANNERS = 'api/SETTINGS_BANNERS';
export const SMS_LOGIN = 'api/SMS_LOGIN';
export const SMS_VERIFICATION = 'api/SMS_VERIFICATION';
export const SPORTS_LIST = 'api/SPORTS_LIST';
export const STATIC_CONTENT = 'api/STATIC_CONTENT';
export const SUBMIT_SUPEROVER_SCORE = 'SUBMIT_SUPEROVER_SCORE';
export const TAKE_A_BREAK = 'api/TAKE_A_BREAK';
export const TOGGLE_COMMUNICATION_PREFERENCES = 'api/TOGGLE_COMMUNICATION_PREFERENCES';
export const TRAINER_COMPLETED_CHALLENGES = 'api/TRAINER_COMPLETED_CHALLENGES';
export const TRAINER_LIVE_CHALLENGES = 'api/TRAINER_LIVE_CHALLENGES';
export const TRAINER_UPCOMING_CHALLENGES = 'api/TRAINER_UPCOMING_CHALLENGES';
export const TRANSACTIONS = 'api/TRANSACTIONS';
export const TOGGLE_LINEUP_FAVORITE = 'api/TOGGLE_LINEUP_FAVORITE';
export const ULTIMATE_CHALLENGE = 'api/ULTIMATE_CHALLENGE';
export const UPCOMING_CHALLENGES = 'api/UPCOMING_CHALLENGES';
export const UPCOMING_CUSTOM_CHALLENGES = 'api/UPCOMING_CUSTOM_CHALLENGES';
export const UPCOMING_H2H_CHALLENGES = 'api/UPCOMING_H2H_CHALLENGES';
export const UPDATE_FRIEND_GROUPS = 'api/UPDATE_FRIEND_GROUPS';
export const UPDATE_GROUP = 'api/UPDATE_GROUP';
export const UPDATE_PHONE = 'api/UPDATE_PHONE';
export const UPLOAD_DOCUMENT = 'api/UPLOAD_DOCUMENT';
export const USER_BALANCE = 'api/USER_BALANCE';
export const USER_DETAILS = 'api/USER_DETAILS';
export const USER_QUESTIONS = 'api/USER_QUESTIONS';
export const USER_SIGN_IN = 'api/USER_SIGN_IN';
export const USER_SIGN_OUT = 'api/USER_SIGN_OUT';
export const USER_SIGN_UP = 'api/USER_SIGN_UP';
export const USER_TERMS = 'api/USER_TERMS';
export const USER_UPDATE = 'api/USER_UPDATE';
export const USER_WITHDRAWAL = 'api/USER_WITHDRAWAL';
export const VERIFY_PHONE = 'api/VERIFY_PHONE';
export const WITHDRAWAL_ACCOUNTS = 'api/WITHDRAWAL_ACCOUNTS';
export const PORTAL_SIGN_IN = 'api/PORTAL_SIGN_IN';
